import { h } from 'preact';
import { PLACEHOLDER_TYPE } from 'utils/constants';
import { hasUnpublishedPlaceholderChanges, getMovieType, getMovieTypeLabel } from 'utils/data';

import Badge from 'components/badge';
import MovieList from 'components/list/movieList/movieList.js';

import s from 'components/list/movieList/movieListUniversal.sss';

export default class UniversalMovieList extends MovieList {
	s = s;

	getHeroImage(item) {
		const localeHero = item?.content?.hero?.desktop?.still || {};
		const baseHero = item?.base_movie?.content?.hero?.desktop?.still || {};
		return {
			...baseHero,
			...localeHero,
			url: localeHero?.url || baseHero?.url || this.defaultHeroImage,
		};
	}

	renderBadge(live, changes) {
		return <Badge class={this.s.badge} type={live ? 'live' : 'draft'} alert={live && changes} />;
	}

	renderPlaceholderBadge(item) {
		// Determine if there are unpublished changes specifically for the placeholder page
		const unpublishedChanges = hasUnpublishedPlaceholderChanges(item);
		const isLive = item?.commits?.publish?.published_status?.endsWith(PLACEHOLDER_TYPE.toUpperCase());

		return this.renderBadge(isLive, unpublishedChanges);
	}

	renderMoviePlatformBadge(item) {
		const { current, publish } = item?.commits || {};
		const unpublishedChanges = current?.at > publish?.at;
		const moviePageType = getMovieType(item);
		const isLive = publish?.published_status?.endsWith(moviePageType.toUpperCase());

		return this.renderBadge(isLive, unpublishedChanges);
	}

	renderStatus(item) {
		if (this.isBase) return null;

		const moviePageType = getMovieType(item);
		const isMoviePageLive = item?.commits?.publish?.published_status?.endsWith(moviePageType.toUpperCase());
		return (
			<div>
				{!isMoviePageLive && (
					<div class={s.status}>
						<div class={s.statusLabel}>Holding Page</div>
						{this.renderPlaceholderBadge(item)}
					</div>
				)}
				<div class={s.status}>
					<div class={s.statusLabel}>{getMovieTypeLabel(moviePageType)}</div>
					{this.renderMoviePlatformBadge(item)}
				</div>
			</div>
		);
	}
}